module.exports = __webpack_public_path__ + "img/smooth-pk-chart-mobile-noicon.d539b02a.png";